import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';

export const BannerCarousel = ({ images = [] }) => {
  if (!images || images.length === 0) {
    return (
      <div className="banner-carousel-placeholder">
        <div className="banner-carousel-loading">Carregando banners...</div>
      </div>
    );
  }

  return (
    <div className="banner-carousel-container">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={images.length > 1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        className="banner-carousel-swiper"
      >
        {images.map((image) => (
          <SwiperSlide key={image.id}>
            <img
              src={image.uri}
              alt={`Banner ${image.id}`}
              className="banner-carousel-image"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
